/**
 * This file was auto-generated from the openapi generate script.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars, @stylistic/max-len */

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../auth/auth.service';
import EnvService from '../../app.env';
import type { components } from './public';

export type UntaggedBaggagesReadVars = { baggageId: string };
export type ClaimsReadVars = { refId: string, tag9Char: string };
export type ClaimsOperatorDecisionUpdateVars = { refId: string, tag9Char: string };

export type UntaggedBaggagesSearchQuery = { pageSize?: string, page: string, q?: string, type: UntaggedBaggagesSearchType };
export type ClaimsSearchQuery = { pageSize?: string, page: string, q?: string };

export type UntaggedBaggagesReadParameters = { baggageId: string };
export type UntaggedBaggagesSearchParameters = { pageSize?: string, page: string, q?: string, type: UntaggedBaggagesSearchType };
export type ClaimsSearchParameters = { pageSize?: string, page: string, q?: string };
export type ClaimsReadParameters = { refId: string, tag9Char: string };
export type ClaimsOperatorDecisionUpdateParameters = { refId: string, tag9Char: string };

export const UNTAGGED_BAGGAGES_SEARCH_TYPE = ['inventory', 'search'] as const;
export const CAMERA = ['FRONT_CAMERA', 'LEFT_CAMERA', 'RIGHT_CAMERA', 'REAR_CAMERA', 'TOP_CAMERA'] as const;
export const TABLET_VIEW = ['FRONT-VIEW-1', 'FRONT-VIEW-2', 'FRONT-VIEW-3', 'FRONT-VIEW-4', 'BACK-VIEW-1', 'BACK-VIEW-2', 'BACK-VIEW-3', 'BACK-VIEW-4'] as const;
export const CLOUD_MATCHER_TRANSACTION_STATE = ['IN_PROGRESS', 'DONE', 'ERROR', 'VOID'] as const;
export const ON_BOARD_EVENT_TYPE = ['BaggageToAircraftLoad', 'BaggageToAircraftOrContainerOffload'] as const;
export const UNIT_LOADS_EVENT_TYPE = ['BaggageToContainerLoad', 'ContainerToContainerLoad', 'ContainerToAircraftLoad', 'ContainerToAircraftOffload'] as const;
export const CLAIM_PROVIDER_STATE = ['OPENED', 'SUSPENDED', 'CLOSED'] as const;
export const CLAIM_SEARCH_STATE = ['NEW', 'SEARCHING', 'SEARCHED', 'CLOSED', 'ERROR', 'NEW_PENDING'] as const;
export const CLAIM_OPERATOR_DECISION_STATE = ['NONE', 'FOUND', 'NOT_FOUND'] as const;
export const CLAIM_RESULT_RELATION = ['TAG', 'PASSENGER_NAME_RECORD', 'FREQUENT_FLYER_NUMBER'] as const;

export type UntaggedBaggagesSearchType = components['schemas']['UntaggedBaggagesSearchType'];
export type Camera = components['schemas']['Camera'];
export type TabletView = components['schemas']['TabletView'];
export type imagesDictionary = components['schemas']['imagesDictionary'];
export type Device = components['schemas']['Device'];
export type AlixResponse = components['schemas']['AlixResponse'];
export type CloudMatcherCandidate = components['schemas']['CloudMatcherCandidate'];
export type CloudMatcherTransactionState = components['schemas']['CloudMatcherTransactionState'];
export type CloudMatcherTransactionCreateValue = components['schemas']['CloudMatcherTransactionCreateValue'];
export type CloudMatcherTransactionErrorValue = components['schemas']['CloudMatcherTransactionErrorValue'];
export type CloudMatcherTransactionCreate = components['schemas']['CloudMatcherTransactionCreate'];
export type CloudMatcherTransactionMatchValue = components['schemas']['CloudMatcherTransactionMatchValue'];
export type CloudMatcherTransactionMatch = components['schemas']['CloudMatcherTransactionMatch'];
export type AirfranceEventResponse = components['schemas']['AirfranceEventResponse'];
export type IagEventResponse = components['schemas']['IagEventResponse'];
export type CrossingPoint = components['schemas']['CrossingPoint'];
export type BaggageSource = components['schemas']['BaggageSource'];
export type FlightSegment = components['schemas']['FlightSegment'];
export type FlightSegments = components['schemas']['FlightSegments'];
export type CrossingPointCreatedEventResponse = components['schemas']['CrossingPointCreatedEventResponse'];
export type TaggedBaggagesCreatedEventResponse = components['schemas']['TaggedBaggagesCreatedEventResponse'];
export type TaglessBaggage = components['schemas']['TaglessBaggage'];
export type UntaggedBaggage = components['schemas']['UntaggedBaggage'];
export type TaggedBaggage = components['schemas']['TaggedBaggage'];
export type TaggedBaggageKeysOnly = components['schemas']['TaggedBaggageKeysOnly'];
export type TaggedBaggageSecondaryKeysOnly = components['schemas']['TaggedBaggageSecondaryKeysOnly'];
export type AssociationImagesSetCrossingPoint = components['schemas']['AssociationImagesSetCrossingPoint'];
export type UntaggedBaggageResponse = components['schemas']['UntaggedBaggageResponse'];
export type UntaggedBaggagesResponse = components['schemas']['UntaggedBaggagesResponse'];
export type UntaggedBaggageTransactionCreate = components['schemas']['UntaggedBaggageTransactionCreate'];
export type ImagesSetImage = components['schemas']['ImagesSetImage'];
export type ImagesSet = components['schemas']['ImagesSet'];
export type ImagesSetPublic = components['schemas']['ImagesSetPublic'];
export type ImagesSetsResponse = components['schemas']['ImagesSetsResponse'];
export type ImagesSetRequest = components['schemas']['ImagesSetRequest'];
export type UntaggedBaggageCreateBody = components['schemas']['UntaggedBaggageCreateBody'];
export type BaggageToAircraftLoad = components['schemas']['BaggageToAircraftLoad'];
export type BaggageToAircraftOrContainerOffload = components['schemas']['BaggageToAircraftOrContainerOffload'];
export type BaggageToContainerLoad = components['schemas']['BaggageToContainerLoad'];
export type ContainerToContainerLoad = components['schemas']['ContainerToContainerLoad'];
export type ContainerToAircraftLoad = components['schemas']['ContainerToAircraftLoad'];
export type ContainerToAircraftOffload = components['schemas']['ContainerToAircraftOffload'];
export type OnBoardEventType = components['schemas']['OnBoardEventType'];
export type OnBoardBaggage = components['schemas']['OnBoardBaggage'];
export type OnBoardEvent = components['schemas']['OnBoardEvent'];
export type UnitLoadsEventType = components['schemas']['UnitLoadsEventType'];
export type Counter = components['schemas']['Counter'];
export type UnitLoadsEvent = components['schemas']['UnitLoadsEvent'];
export type UnitLoadsDevice = components['schemas']['UnitLoadsDevice'];
export type ErrorResponse = components['schemas']['ErrorResponse'];
export type ClaimsUploadBody = components['schemas']['ClaimsUploadBody'];
export type ClaimProviderState = components['schemas']['ClaimProviderState'];
export type ClaimSearchState = components['schemas']['ClaimSearchState'];
export type ClaimsOperatorDecisionUpdateBody = components['schemas']['ClaimsOperatorDecisionUpdateBody'];
export type ClaimOperatorDecisionState = components['schemas']['ClaimOperatorDecisionState'];
export type ClaimResultRelation = components['schemas']['ClaimResultRelation'];
export type ClaimResultRelatedTaggedBaggage = components['schemas']['ClaimResultRelatedTaggedBaggage'];
export type PublicClaimResultRelatedTaggedBaggage = components['schemas']['PublicClaimResultRelatedTaggedBaggage'];
export type ClaimResultUntaggedBaggage = components['schemas']['ClaimResultUntaggedBaggage'];
export type PublicClaimResultUntaggedBaggage = components['schemas']['PublicClaimResultUntaggedBaggage'];
export type ClaimResultTaggedBaggage = components['schemas']['ClaimResultTaggedBaggage'];
export type PublicClaimResultTaggedBaggage = components['schemas']['PublicClaimResultTaggedBaggage'];
export type ClaimsCloudMatcherNotifDone = components['schemas']['ClaimsCloudMatcherNotifDone'];
export type ClaimsCloudMatcherNotifError = components['schemas']['ClaimsCloudMatcherNotifError'];
export type ClaimKeysOnly = components['schemas']['ClaimKeysOnly'];
export type Claim = components['schemas']['Claim'];
export type PublicClaim = components['schemas']['PublicClaim'];
export type ClaimsResponse = components['schemas']['ClaimsResponse'];
export type ClaimResponse = components['schemas']['ClaimResponse'];
export type ClaimsSearch = components['schemas']['ClaimsSearch'];
export type AirfranceClaimsCreateResponseClaim = components['schemas']['AirfranceClaimsCreateResponseClaim'];
export type AirfranceClaimsCreateResponse = components['schemas']['AirfranceClaimsCreateResponse'];
export type AirfranceClaim = components['schemas']['AirfranceClaim'];
export type UntaggedBaggageSearchResponse = components['schemas']['UntaggedBaggageSearchResponse'];
export type TabletImagesCreateBody = components['schemas']['TabletImagesCreateBody'];
export type TabletImagesCreateResponse = components['schemas']['TabletImagesCreateResponse'];

@Injectable({
  providedIn: 'root',
})
export default class PublicClient {
  private readonly domain: string;

  private readonly headers = () => new HttpHeaders({ Authorization: `Bearer ${this.authService.accessToken}` });

  private readonly httpClient = inject(HttpClient);

  private readonly env = inject(EnvService);

  private readonly authService = inject(AuthService);

  constructor() {
    this.domain = this.env.value('PUBLIC_CLIENT_DOMAIN');
  }

  /**
   * @description [GET] /alix: Return the Alix server infos
   */
  alixRead() {
    return this.httpClient.get<AlixResponse>(`${this.domain}/alix`, { headers: this.headers() });
  }

  /**
   * @description [GET] /untagged-baggages/{baggageId}: Return the Untagged Baggage details from the its id
   */
  untaggedBaggagesRead(vars: UntaggedBaggagesReadVars) {
    return this.httpClient.get<UntaggedBaggageResponse>(`${this.domain}/untagged-baggages/${vars.baggageId}`, { headers: this.headers() });
  }

  /**
   * @description [GET] /untagged-baggages/search: Return a list of UntaggedBaggages matching given criterias
   */
  untaggedBaggagesSearch(query: UntaggedBaggagesSearchQuery) {
    return this.httpClient.get<UntaggedBaggageSearchResponse>(`${this.domain}/untagged-baggages/search`, { params: query, headers: this.headers() });
  }

  /**
   * @description [POST] /tablet/images: Upload Untagged Baggages Images to backend
   */
  tabletImagesCreate(body: TabletImagesCreateBody) {
    return this.httpClient.post<TabletImagesCreateResponse>(`${this.domain}/tablet/images`, body, { headers: this.headers() });
  }

  /**
   * @description [POST] /airfrance/claims: Upload claims from CSV file
   */
  airfranceClaimsCreate(body: FormData) {
    return this.httpClient.post<AirfranceClaimsCreateResponse>(`${this.domain}/airfrance/claims`, body, { headers: this.headers() });
  }

  /**
   * @description [GET] /claims/search: Return a list of Claims matching given criterias
   */
  claimsSearch(query: ClaimsSearchQuery) {
    return this.httpClient.get<ClaimsResponse>(`${this.domain}/claims/search`, { params: query, headers: this.headers() });
  }

  /**
   * @description [GET] /claims/{refId}/{tag9Char}: Return claim based on refId.
   */
  claimsRead(vars: ClaimsReadVars) {
    return this.httpClient.get<ClaimResponse>(`${this.domain}/claims/${vars.refId}/${vars.tag9Char}`, { headers: this.headers() });
  }

  /**
   * @description [POST] /claims/{refId}/{tag9Char}: Update claim search state based on operator decision.
   */
  claimsOperatorDecisionUpdate(vars: ClaimsOperatorDecisionUpdateVars, body: ClaimsOperatorDecisionUpdateBody) {
    return this.httpClient.post<ClaimResponse>(`${this.domain}/claims/${vars.refId}/${vars.tag9Char}`, body, { headers: this.headers() });
  }

  /**
   * @description [POST] /airfrance/event: Post a BSM/BPM Airfrance event directly to the airfrance-bridge bypassing the ActiveMQ
   */
  airfranceEventCreate(body: string) {
    return this.httpClient.post<AirfranceEventResponse>(`${this.domain}/airfrance/event`, body, { headers: this.headers() });
  }

  /**
   * @description [POST] /iag/event: Post a BSM/BPM IAG event directly to the iag-bridge bypassing the ActiveMQ
   */
  iagEventCreate(body: string) {
    return this.httpClient.post<IagEventResponse>(`${this.domain}/iag/event`, body, { headers: this.headers() });
  }
}
